import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function PastaBake() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Pasta Bake</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>1 red pepper, seeds
        removed, cut into bite-size chunks<br></br>1 yellow pepper, seeds
        removed, cut into bite-size chunks<br></br>1 aubergine, finely chopped
        <br></br>1 courgette, finely chopped<br></br>1 red onion, sliced
        <br></br>3 tbsp olive oil<br></br>
        150g/5½oz cherry tomatoes, halved<br></br>
        400g tin chopped tomatoes<br></br>2 garlic cloves, crushed<br></br>3
        tbsp roughly chopped basil<br></br>
        300g/10½oz pasta, such as gemelli or penne<br></br>
        150g/5½oz ball mozzarella, drained and finely chopped<br></br>2 tbsp
        pesto<br></br>
        2-3 tbsp finely grated Parmesan, or a vegetarian hard cheese alternative
        <br></br>
        salt and freshly ground black pepper<br></br>
      </Typography>

      <Typography>
        Preheat the oven to 190C/170C Fan/Gas 5.<br></br>
        <br></br>
        Put the peppers, aubergine, courgette and onion into a roasting tin or
        deep baking dish and coat in the oil. <br></br>
        Season with salt and pepper and cook for 45 minutes, turning twice,
        until the vegetables are tender and golden brown.<br></br>
        <br></br>
        Add the cherry tomatoes, chopped tomatoes, garlic and basil and cook for
        10-15 minutes.<br></br>
        <br></br>
        Meanwhile, cook the pasta in boiling salted water according to pack
        instructions. <br></br>
        Add 4-6 tablespoons of the pasta cooking water to the vegetables to
        loosen the tomato sauce.<br></br>
        <br></br>
        Drain the pasta and stir into the roasted vegetables. <br></br>
        Stir through the mozzarella and pesto, top with Parmesan and return to
        the oven for another 10 minutes, until the cheese has melted.<br></br>
      </Typography>
    </Card>
  );
}
